import styled from '@emotion/styled';

export const InvitationCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing[8],
  padding: theme.spacing[16],
  borderRadius: theme.radius[12],
  border: `1px solid ${theme.colors.border.default}`,
  backgroundColor: theme.colors.background.overlay,
}));

export const InvitationEmail = styled('div')(({ theme }) => ({
  padding: theme.spacing[6],
  borderRadius: theme.radius[6],
  backgroundColor: theme.colors.background.canvas,
}));
